module.exports = __webpack_public_path__ + "img/btn_loyalty.ba65bfb6.png";